export default {"src":"/_next/static/media/icon-deals.82e7df35.svg","height":19,"width":17,"blurWidth":0,"blurHeight":0};